module.exports = __webpack_public_path__ + "static/media/inform-architech.9bc05873.png";